export const PageCodesHero = Object.freeze({
  PetInsurance: 1,
  LifeInsurance: 2,
});
